import { Helmet } from 'react-helmet-async';

export default function Meta({ meta }) {
    // SEO meta tags are now managed in index.html
    // This component can be used for page-specific meta overrides if needed
    if (null == meta) {
        return null; // Use default meta tags from index.html
    }
    
    return (
        <Helmet>
            {meta.title && <title>{meta.title}</title>}
            {meta.keywords && <meta name="keywords" content={meta.keywords} />}
            {meta.description && <meta name="description" content={meta.description} />}
            {meta.title && <meta property="og:title" content={meta.title} />}
            {meta.description && <meta property="og:description" content={meta.description} />}
        </Helmet>
    )
}